import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import Button from "../../../shared/button/button";
import ConfirmCheckbox from "../../../shared/FormikFields/confirmCheckbox";
import { LOAN_AGREEMENT_CONSENTS } from "./utils";
import {
  AgreementBody,
  AgreementButtons,
  AgreementsWrapper,
  CheckboxAndTextWrapper,
  ConsentList,
  ConsentRow,
} from "./style";
import SafeHtml from "../../common/SafeHtml";

export default function AgreementsForm({
  agreements,
  setAgreementValues,
  prevStep,
}) {
  const { t } = useTranslation();
  const { values, setFieldValue, setFieldTouched, handleSubmit, errors, touched, isSubmitting } =
    useFormikContext();
  const isAgreementsChecked = LOAN_AGREEMENT_CONSENTS.every(
    ({ name, required }) => !required || values[name] === true,
  );
  const consents = LOAN_AGREEMENT_CONSENTS.map((consent) => ({
    ...consent,
    text: t(consent.translationKey),
  }));
  const displayedAgreements = [...(agreements ?? [])];
  if (displayedAgreements.length > 1) {
    const lastIndex = displayedAgreements.length - 1;
    [displayedAgreements[0], displayedAgreements[lastIndex]] =
      [displayedAgreements[lastIndex], displayedAgreements[0]];
  }
  if (displayedAgreements.length > 3) {
    [displayedAgreements[2], displayedAgreements[3]] =
      [displayedAgreements[3], displayedAgreements[2]];
  }

  function handleConsentChange(e) {
    const { name, checked } = e.target;
    setFieldValue(name, checked);
    setAgreementValues((current) => ({ ...current, [name]: checked }));
  }

  return (
    <div className="w-full">
      <AgreementsWrapper>
        <AgreementBody
          role="region"
          aria-labelledby={consents.map(({ name }) => `${name}-label`).join(" ")}
          tabIndex={0}
        >
          {displayedAgreements.map((html, index) =>
            html ? (
              <CheckboxAndTextWrapper as="section" key={index}>
                <SafeHtml html={html} />
              </CheckboxAndTextWrapper>
            ) : null,
          )}
        </AgreementBody>
        <ConsentList>
          {consents.map(({ name, text }) => (
            <ConsentRow
              key={name}
              id={`${name}-label`}
              $hasError={Boolean(touched[name] && errors[name])}
              onBlurCapture={() => setFieldTouched(name, true)}
            >
              <ConfirmCheckbox
                name={name}
                checked={Boolean(values[name])}
                onChange={handleConsentChange}
                touched={{}}
                errors={errors}
                text={text}
                checkBoxAlignItems="flex-start"
                isBold
              />
            </ConsentRow>
          ))}
        </ConsentList>
      </AgreementsWrapper>
      <AgreementButtons>
        <Button variant="inherit" onClick={prevStep} type="button" disabled={isSubmitting}>
          {t("prev")}
        </Button>
        <Button
          disabled={!isAgreementsChecked || isSubmitting}
          variant={isAgreementsChecked && !isSubmitting ? "primary" : "disabled"}
          onClick={handleSubmit}
          type="submit"
        >
          {t("next")}
        </Button>
      </AgreementButtons>
    </div>
  );
}
